/* eslint-disable react/destructuring-assignment */
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { FormattedMessage } from "react-intl";

import DropdownCommon, { DropdownCommonProps } from "./DropdownCommon";

export type DropdownWithFormProps = Omit<DropdownCommonProps, "value" | "hasError"> & {
  name?: string;
  required?: boolean;
  validations?: object;
  shouldUnregister?: boolean;
  defaultValue?: string | number;
};

function DropdownWithForm(props: DropdownWithFormProps) {
  const { name = "", required, validations, defaultValue, shouldUnregister } = props;
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      rules={{ required, ...validations }}
      name={name}
      defaultValue={defaultValue}
      shouldUnregister={shouldUnregister}
      render={({ field: { onChange, value, ref, ...rest }, fieldState: { error } }) => (
        <>
          <DropdownCommon
            {...props}
            {...rest}
            value={value}
            hasError={!!error}
            onChange={(val: any) => {
              onChange(val?.value);
              if (props.onChange) {
                props.onChange(val);
              }
            }}
          />
          {error && (
            <div className="d-block font-b3 invalid-feedback">
              {error?.message ? (
                error.message
              ) : (
                <FormattedMessage id="general.requiredField" defaultMessage="This is a required field" />
              )}
            </div>
          )}
        </>
      )}
    />
  );
}

export default DropdownWithForm;

DropdownWithForm.defaultProps = {
  name: "",
  required: false,
  validations: undefined,
  shouldUnregister: false,
  defaultValue: "",
};
